
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {
    PhoneInput: () => import("@/components/Jobs/Profile/PhoneInput.vue")
  }
})
export default class AddPhone extends Vue {
  @Prop(Function) closeAddPhone!: any;
  numberInvalid = false;
  errorPhone = {
    flag: true,
    type: ""
  };
  phone = {
    phonepais: "",
    phonearea: null,
    phone: null
  };

  async savePhone() {
    const _this: any = this;

    let phone1 = null;
    let phone = null;

    if (
      (this as any).phone.phone !== "" ||
      (this as any).phone.phonepais !== "" ||
      (this as any).phone.phonearea !== ""
    ) {
      phone1 = `${(this as any).$root.getPhoneCountryCode(
        (this as any).phone.phonepais
      )}${(this as any).$root.getPhoneAreaCode(
        (this as any).phone.phonearea
      )}${(this as any).$root.getPhoneNumber((this as any).phone.phone)}`;
      phone = _this.$root.parsePhone(phone1);
    }
    let nu = _this.$store.state.user.nucleus_user;
    nu.te_nro = phone ? phone.nu_nro : "";
    nu.c_area = phone ? phone.nu_area : "";
    nu.c_pais = phone ? phone.nu_pais : "";
    await _this.$root._put(`user/${_this.$store.state.user.id}`, {
      second_phone: phone1,
      nucleus_user: nu
    });
    await _this.$root.reloadUser();
    this.$emit("changeUserPhone", _this.$store.state.user);
    _this.closeAddPhone();
  }
}
